import { useLocation } from 'react-router-dom';
import { useStandardAlertStore } from '../store/portal/alertStore';
import { useEditMode } from './useEditMode';
import { useModalStore } from '../store/portal/modalStore';
import { useIsPageOwner } from './useIsPageOwner';
import { scrollToChangedElement } from './useUnsavedChanges';
import { hasUnsavedChanges } from './useCheckBeforeMove';

interface UseShortCutResult {
  handleCmdE: (e: React.KeyboardEvent) => void;
  handleCmdSlash: (e: React.KeyboardEvent, toggleContentMode: () => void) => void;
  scrollToChangedElement: () => void;
}

export const useShortCut = (): UseShortCutResult => {
  const { pathname } = useLocation();
  const isOwner = useIsPageOwner();
  const { isEditMode, setEditMode } = useEditMode();
  const setUnchangedAlert = useStandardAlertStore((state) => state.setUnchangedAlert);
  const isModalOpen = useModalStore((state) => state.standardModal !== null);

  const handleCmdE = (e: React.KeyboardEvent) => {
    if (isModalOpen) return;
    switch (e.key) {
      case 'e':
        if (e.metaKey || e.ctrlKey) {        // Cmd+E (macOS) 또는 Ctrl+E (Windows) 키 조합 감지
          e.preventDefault();
          if (isOwner) {
            if (!isEditMode) {
              setEditMode(true);
            } else {
              // 호출 시점 store 스냅샷 — 페이지 루트 dirty 구독 불필요
              if (hasUnsavedChanges(pathname)) {
                // 편집 모드 종료 시 변경사항이 있으면 스크롤
                setTimeout(() => scrollToChangedElement(), 100); // 약간의 지연으로 DOM 업데이트 대기
                setUnchangedAlert(() => {
                  setEditMode(false);
                  window.location.reload(); // 새로고침이 편하긴 해...
                });
              } else {
                setEditMode(false);
              }
            }
          }
        }
        break;
      default:
        break;
    }
  };

  const handleCmdSlash = (
    e: React.KeyboardEvent,
    toggleContentMode: () => void,
  ) => {
    if (isModalOpen) return;
    if ((e.metaKey || e.ctrlKey) && e.code === 'Slash') {
      e.preventDefault();
      toggleContentMode();
    }
  };

  return { handleCmdE, handleCmdSlash, scrollToChangedElement };
}
